import { Button, CircularProgress } from '@mui/material'
import * as React from 'react'
import { PartnerContext } from './PartnerContext'
import { uploadIngestionFile } from 'components/ingestion/Utility'
import { fileFromJson } from 'shared/utils'
import { openTab } from 'components/Helpers'
import { previewUrl } from 'infrastructure/api'
import { CollapsableJson } from 'shared/ui'

interface ICollapsableParams {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  json: any
  title: string
  disabled?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraButtons?: any
  collapsed?: boolean
}

export function IngestableJson(params: ICollapsableParams) {
  const partnerId = React.useContext(PartnerContext)
  const [previewFile, setPreviewFile] = React.useState<string | undefined>(
    undefined,
  )
  const [loading, setLoading] = React.useState(false)

  const ingestDisabled = params.disabled ?? false

  async function ingest() {
    setLoading(true)
    try {
      const fileName = await uploadIngestionFile(
        partnerId!,
        fileFromJson(params.json, 'ingested'),
        () => {},
      )
      setPreviewFile(fileName)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const openPreview = () => {
    if (partnerId && previewFile)
      openTab(previewUrl({ partnerKey: partnerId, ingestionKey: previewFile }))
  }
  const extraButtons = !loading ? (
    <>
      <Button key={'ingest'} onClick={ingest} disabled={ingestDisabled}>
        Ingest
      </Button>
      {!ingestDisabled && partnerId && previewFile && (
        <Button key={'preview'} onClick={openPreview}>
          Preview
        </Button>
      )}
    </>
  ) : (
    <CircularProgress
      variant="indeterminate"
      size={'1em'}
      sx={{ marginLeft: '3em' }}
    ></CircularProgress>
  )

  return <CollapsableJson {...params} extraButtons={[extraButtons]} />
}
